export default __webpack_public_path__ + "images/SP.8c4bfe5.png";